import tippy, {followCursor} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css'

document.addEventListener("DOMContentLoaded", function() {
    tippy('.tippy', {
        arrow: true,
        theme: 'light',
        followCursor: true,
        plugins: [followCursor],
    });
});
